import { StepType } from '@reactour/tour';

export const tourSteps: StepType[] = [
  {
    selector: '.tour-layout-toggle',
    content: 'tour.step1',
  },
  {
    selector: '.tour-pick-data',
    content: 'tour.step2',
  },
  {
    selector: '.tour-data-catalogue',
    content: 'tour.step3',
  },
  {
    selector: '.tour-summarise-by',
    content: 'tour.step4',
  },
  {
    selector: '.tour-calculated-fields',
    content: 'tour.step5',
  },
  {
    selector: '.tour-chart-tab',
    content: 'tour.step6',
    action: () => {
      const event = new CustomEvent('tour-switch-tab', { 
        detail: { tabKey: 'charts' },
      });
      window.dispatchEvent(event);
    },
  },
  {
    selector: '.tour-filters-tab',
    content: 'tour.step7',
    action: () => {
      const event = new CustomEvent('tour-switch-tab', { 
        detail: { tabKey: 'filters' },
      });
      window.dispatchEvent(event);
    },
  },
];

